import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  DeleteWorkstep,
  DeleteWorkstepComponent,
  EditWorkStep,
  EditWorkstepComponent,
} from "../../../actions/teacherMutations";

export default function useAPLWorkStepMutations(intl, level, activePeriodId, objId) {
  const [promtWorkComponentForDelete, setPromptComponentForDelete] =
    useState(null);
  const [workcardItemForEditName, setWorkcardItemForEditName] = useState(null);

  const queryClient = useQueryClient();

  const deleteWorkstep = useMutation({ mutationFn: DeleteWorkstep });
  const deleteWorkstepComponent = useMutation({ mutationFn: DeleteWorkstepComponent });
  const editWorkStep = useMutation({ mutationFn: EditWorkStep });
  const editWorkStepComponent = useMutation({ mutationFn: EditWorkstepComponent });

  const handleDeleteItem = () => {
    if (promtWorkComponentForDelete.isWorkstep) {
      deleteWorkstep.mutate(promtWorkComponentForDelete.id, {
        onError: (data) => {
          toast.warn(data.response.data);
        },
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            toast.success(
              intl.formatMessage(
                { id: "WorkstepNameDeleted" },
                {
                  name: promtWorkComponentForDelete.name,
                }
              )
            );
            queryClient.invalidateQueries({ queryKey: [
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ] });
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
          }
        },
      });
    } else if (!promtWorkComponentForDelete.isWorkstep) {
      deleteWorkstepComponent.mutate(promtWorkComponentForDelete.id, {
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            queryClient.invalidateQueries({ queryKey: [
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ] });
            toast.success(
              intl.formatMessage(
                { id: "WorkstepComponentNameDeleted" },
                {
                  name: promtWorkComponentForDelete.name,
                }
              )
            );
            setWorkcardItemForEditName(null);
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
          }
        },
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    }
    setPromptComponentForDelete(null);
  };

  const handleChangeNameOnWorkcardItem = () => {
    if (workcardItemForEditName.isWorkstep) {
      editWorkStep.mutate(workcardItemForEditName, {
        onError: (data) => {
          toast.warn(data.response.data);
        },
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            toast.success(
              intl.formatMessage(
                { id: "WorkstepNameChangedTo" },
                {
                  name: workcardItemForEditName.name,
                }
              )
            );
            queryClient.invalidateQueries({ queryKey: [
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ] });
            setWorkcardItemForEditName(null);
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
            setWorkcardItemForEditName(null);
          }
        },
      });
    } else if (!workcardItemForEditName.isWorkstep) {
      editWorkStepComponent.mutate(workcardItemForEditName, {
        onSuccess: (data) => {
          if (data?.status > 199 && data.status < 300) {
            queryClient.invalidateQueries({ queryKey: [
              "FetchWorkCardHours",
              [level, activePeriodId, objId],
            ] });
            toast.success(
              intl.formatMessage(
                { id: "WorkstepComponentNameChangedTo" },
                {
                  name: workcardItemForEditName.name,
                }
              )
            );
            setWorkcardItemForEditName(null);
          } else {
            toast.warn(intl.formatMessage({ id: data.trim() }));
            setWorkcardItemForEditName(null);
          }
        },
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    }
    setPromptComponentForDelete(null);
  };

  const handleSetWorkcardItemForEditName = (val) => {
    setWorkcardItemForEditName({ ...workcardItemForEditName, name: val });
  };

  return {
    promtWorkComponentForDelete,
    setPromptComponentForDelete,
    workcardItemForEditName,
    setWorkcardItemForEditName,
    handleDeleteItem,
    handleChangeNameOnWorkcardItem,
    handleSetWorkcardItemForEditName,
  };
}
